import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    position: 'relative'
  },
  inputLabel: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontFamily: 'Inter, sans-serif',
    fontSize: '1rem',
    transition: 'color 0.2s ease'
  },
  inputLabelFocused: {
    color: theme.palette.blue_300.main // Cor azul quando focado
  },
  inputField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px'
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.blue_300.main,
      borderWidth: '2px'
    },

    // Hover state (opcional)
    '&:hover fieldset': {
      borderColor: theme.palette.blue_300.main
    },
    '& svg': {
      color: theme.palette.gray_400.main
    },

    '& input[type="time"]::-webkit-calendar-picker-indicator': {
      // display: 'none',
    },
    '& input[type="time"]::-webkit-inner-spin-button': {
      // display: 'none'
    },

    '& input': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      padding: '6px 8px',
      borderRadius: '8px',
      fontFamily: '"Roboto", "Noto Color Emoji", sans-serif'
    },
    '& textarea': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      fontFamily: '"Roboto", "Noto Color Emoji", sans-serif'
    }
  },
  iconButton: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}))
